import { Box, DashboardModule } from '@domain-group/suit-theme'

import useAssignTemplatePagePermissions from '../../hooks/useAssignTemplatePagePermissionsModal'

import EntityFilters from '../EntityFilters'
import EntityList from '../EntityList'

import Publication from './Publication'

interface PublicationsProps {
  assignTemplatePagePermissionsPayload: ReturnType<typeof useAssignTemplatePagePermissions>,
}

const Publications = (props: PublicationsProps) => {
  const { assignTemplatePagePermissionsPayload } = props

  return (
    <DashboardModule title="Publications">
      <Box flexDirection="column" padding="large">
        <EntityFilters
          assignTemplatePagePermissionsPayload={assignTemplatePagePermissionsPayload}
          entityName="Publications"
        />

        <EntityList
          assignTemplatePagePermissionsPayload={assignTemplatePagePermissionsPayload}
          entityKey="publicationIds"
          // @ts-expect-error TS2322
          entityListItemComponent={Publication}
        />
      </Box>
    </DashboardModule>
  )
}

export default Publications
